import React from "react";
import AbitlityContext from "./AbitlityContext";

export const checkAbilities = (userAbilities: any, allowedAbilities: any) => {
  if (allowedAbilities.length === 0) return true;

  return userAbilities.some((ability: string) => allowedAbilities.includes(ability));
};


interface CanProps {
  abilities: string[];
  children: React.ReactNode;
}

const Can = ({ children, abilities }: CanProps) => {
  const { abilities: userAbilities } = React.useContext(AbitlityContext);
  const ablited = checkAbilities(userAbilities, abilities);

  return <>{ablited ? children : null}</>;
};

Can.defaultProps = {
  abilities: [],
};
export default Can;
